import BookDataTable from '../../../features/book-management/book-list/BookDataTable'
import BookFilterHeader from '../../../features/book-management/book-list/BookFilterHeader'
import { PATH } from '../../../data/router_path'

export default function BookListPage() {
  const path = PATH.BOOK.LIST
  return (
    <div className="flex flex-col">
      <BookFilterHeader title={'Thông tin sách'} path={path} />
      <BookDataTable path={path} />
    </div>
  )
}
